/**
 * Copyright 2022 Design Barn Inc.
 */

import type { Layer } from '@lottiefiles/toolkit-js';

export function removeLayer(layer: Layer): void {
  layer.setIsEnabled(false);
}
